import EventGenerateSlots from '@/screens/EventGenerateSlots';

export default function PrivateEventGenerateSlotsRoute() {
  return <EventGenerateSlots />;
}
